import type { CycleMilestoneTypeValue } from '@/constants/cycle-evaluation/CycleMilestoneType';
import type { CycleMilestone } from '@/types/cycle-evaluation/CycleMilestone';

import { api } from '@/api/api';

export interface CycleMilestoneCreatePayload {
    cycleEvaluationGroupId: string;
    milestoneType: CycleMilestoneTypeValue;
    scheduledAt?: string | null;
}

export interface CycleMilestoneUpdatePayload {
    scheduledAt?: string | null;
}

export default {
    async getCycleMilestonesByCycle(cycleEvaluationGroupId: string): Promise<CycleMilestone[]> {
        const response = await api.get(`/cyclemilestone/by-cycle/${cycleEvaluationGroupId}`);

        return response.data;
    },

    async createCycleMilestone(payload: CycleMilestoneCreatePayload): Promise<CycleMilestone> {
        const response = await api.post('/cyclemilestone', payload);

        return response.data;
    },

    async updateCycleMilestone(
        id: string,
        payload: CycleMilestoneUpdatePayload,
    ): Promise<CycleMilestone> {
        const response = await api.put(`/cyclemilestone/${id}`, payload);

        return response.data;
    },
};
